import {
  head
} from "lodash"

let vRometeJs = {}
vRometeJs.install = function (Vue) {
  Vue.component('remote-css', {
    props: {
      hrefs: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        linkNodes: []
      }
    },
    watch: {
      'hrefs': {
        handler(newVal, oldVal) {
          this.createCss(newVal)
        },
        immediate: true,
      },
    },
    render(createElement) {
      return createElement('div')
    },
    created() {
      this.head = document.head || document.getElementsByTagName('head')[0]
      this.createCss()
    },
    destroyed() {
      this.clearOldCss()
    },
    methods: {
      createCss(hrefs) {
        let _this = this
        this.head = document.head || document.getElementsByTagName('head')[0]
        if (!this.head) {
          return
        }
        if (!hrefs) {
          hrefs = this.hrefs
        }
        this.deleteOldCss()
        hrefs.forEach(href => {
          let loaded = false
          if (_this.linkNodes && _this.linkNodes.length > 0) {
            for (var i = 0; i < _this.linkNodes.length; i++) {
              if (href == _this.linkNodes[i].href) {
                loaded = true
              }
            }
          }

          if (!loaded) {
            let link = document.createElement('link')
            link.href = href
            link.rel = 'stylesheet'
            _this.linkNodes.push(link)
            _this.head.appendChild(link)
          }
        })
      },
      deleteOldCss() {
        let _this = this
        if (_this.linkNodes && _this.linkNodes.length > 0) {
          for (var i = _this.linkNodes.length - 1; i >= 0; i--) {
            let element = _this.linkNodes[i]
            if (_this.hrefs && _this.hrefs.length > 0 && _this.hrefs.includes(element.href) == true) {} else {
              _this.linkNodes.splice(i, 1);
              _this.head.removeChild(element)
            }
          }
        } else {
          this.clearOldCss()
        }
      },
      clearOldCss() {
        let _this = this
        if (_this.linkNodes && this.linkNodes.length > 0) {
          _this.linkNodes.forEach(element => {
            _this.head.removeChild(element)
          });
          _this.linkNodes = []
        }
      }
    }
  })
  Vue.component('remote-js', {
    data() {
      return {
        scriptNodes: []
      }
    },
    props: {
      srcArr: {
        type: Array,
        required: true
      }
    },
    render(createElement) {
      return createElement('div')
    },
    created() {
      this.head = document.head || document.getElementsByTagName('head')[0]
      this.index = 0
      this.createScript(this.srcArr[this.index])
    },
    destroyed() {
      this.scriptNodes.forEach(element => {
        this.head.removeChild(element)
      });
    },
    methods: {
      createScript(src) {
        let script = document.createElement('script')
        script.src = src
        script.type = 'text/javascript'
        this.scriptNodes.push(script)
        this.head.appendChild(script)
        script.onload = () => {
          if (this.index < this.srcArr.length - 1) {
            this.index += 1
            this.createScript(this.srcArr[this.index])
          } else {
            this.$emit('scriptLoad')
          }

        }
      }
    }
  })
}


export default vRometeJs


//   if (typeof exports === 'object') {
//     module.exports = vRometeJs
//   } else if (typeof define === 'function' && define.amd) {
//     define([], function () {
//       return vRometeJs
//     })
//   } else if (window.Vue) {
//     window.vRometeJs = vRometeJs
//     Vue.use(vRometeJs)
//   }



// WEBPACK FOOTER //
// ./src/api/remote-js.js